import { FC } from "react";
import { Flex } from "@mantine/core";
import { useGo } from "@refinedev/core";

import LinkedInIcon from "@images/icons/linkedin.png";
import InstagramIcon from "@images/icons/instagram.png";
import WhatsappIcon from "@images/icons/whatsapp.png";
import EmailIcon from "@images/icons/email.png";
import styles from "@scss/header/header.module.scss";

export const SocialLinks: FC = () => {
  const socialDetails = {
    linkedin: "https://www.linkedin.com/company/ac-brandconsultancy/",
    instagram: "https://www.instagram.com/acbrands",
    whatsapp: "https://wa.me/07773674310",
    email: "ash@acbrands.co.uk",
  };

  const go = useGo();

  const handleLinkedInClick = () => {
    window.open(socialDetails.linkedin, "_blank");
  };

  const handleInstagramClick = () => {
    window.open(socialDetails.instagram, "_blank");
  };

  const handleWhatsappClick = () => {
    window.open(socialDetails.whatsapp, "_blank");
  };

  const handleEmailClick = () => {
    window.open(`mailto:${socialDetails.email}`, "_blank");
  };

  return (
    <Flex
      justify="center"
      align="center"
      gap={"16px"}
      className={styles.socialLinks}
    >
      <img
        src={LinkedInIcon}
        alt="LinkedIn Icon"
        onClick={handleLinkedInClick}
        style={{
          width: "20px",
          height: "20px",
          cursor: "pointer",
        }}
      />
      <img
        src={InstagramIcon}
        alt="Instagram Icon"
        onClick={handleInstagramClick}
        style={{
          width: "20px",
          height: "20px",
          cursor: "pointer",
        }}
      />
      <img
        src={WhatsappIcon}
        alt="Whatsapp Icon"
        onClick={handleWhatsappClick}
        style={{
          width: "20px",
          height: "20px",
          cursor: "pointer",
        }}
      />
      <img
        src={EmailIcon}
        alt="Email Icon"
        onClick={handleEmailClick}
        style={{
          width: "26px",
          height: "auto",
          cursor: "pointer",
          marginLeft: "-5px",
        }}
      />
    </Flex>
  );
};
